import type { Photo } from "../../data/catalog.ts";

export function HeroPhoto({ photo, alt }: { photo: Photo; alt: string }) {
  return (
    <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-slate-100 border border-slate-200/70">
      <img src={photo.signedUrl ?? ""} alt={alt} className="h-full w-full object-contain" />
    </div>
  );
}
